import plur from 'plur'

import type {NormalizedChange} from '../../../../types'
import {internalProps} from '../../../../types/BS_types'
import {limitCount, printCount} from '../../../../utils/printCount'
import {getCommiterName, getSingleUser} from '../Changes.utils'

const CHANGES_LIMIT = Number(internalProps['teamcity.internal.buildChangesPopupLimit'])

const sameAuthor = (a: NormalizedChange, b: NormalizedChange): boolean => {
  const userA = getSingleUser(a)
  const userB = getSingleUser(b)
  if (userA && userB) {
    return userA.id === userB.id
  }

  return a.username === b.username
}

export const getChangesLabel = (
  changes: ReadonlyArray<NormalizedChange> | null | undefined,
  count: number | null | undefined,
): string => {
  if (!changes) {
    switch (count) {
      case null:
      case undefined:
        return 'Calculating...'

      case 0:
        return 'No changes'

      default:
        return `${printCount(count, CHANGES_LIMIT)} ${plur(
          'change',
          limitCount(count, CHANGES_LIMIT),
        )}`
    }
  }

  if (count == null || count === 0) {
    return 'No changes'
  }

  if (changes.every(change => change.isArtifactChange)) {
    return `${printCount(count, CHANGES_LIMIT)} artifact dependency ${plur(
      'change',
      limitCount(count, CHANGES_LIMIT),
    )}`
  }

  const change = changes[0]
  const displayName = getCommiterName(change)

  if (changes.every(x => sameAuthor(x, change))) {
    return `${displayName}: ${printCount(count, CHANGES_LIMIT)}`
  }

  return `${printCount(count, CHANGES_LIMIT)} ${plur('change', limitCount(count, CHANGES_LIMIT))}`
}
